import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import commonEs from './locales/es/common.json'
import errorsEs from './locales/es/errors.json'
import statusEs from './locales/es/status.json'
import layoutEs from './locales/es/layout.json'
import novedadesEs from './locales/es/novedades.json'
import validationEs from './locales/es/validation.json'
import historialEs from './locales/es/historial.json'
import novedadDetailsEs from './locales/es/novedadDetails.json'
import priorityChainEs from './locales/es/priorityChain.json'
import empresasEs from './locales/es/empresas.json'
import usuariosEs from './locales/es/usuarios.json'
import periodosEs from './locales/es/periodos.json'
import parametrosEs from './locales/es/parametros.json'
import parametrosDetailsEs from './locales/es/parametrosDetails.json'
import empresaParametrosEs from './locales/es/empresaParametros.json'
import empresaNovedadDetailsEs from './locales/es/empresaNovedadDetails.json'
import nominaUsuarioDetailsEs from './locales/es/nominaUsuarioDetails.json'
import filtrosEs from './locales/es/filtros.json'
import reintentarModalEs from './locales/es/reintentarModal.json'
import loginErrorModalEs from './locales/es/loginErrorModal.json'
import selectCompanyEs from './locales/es/selectCompany.json'
import protectedRouteEs from './locales/es/protectedRoute.json'
import accountProfileEs from './locales/es/accountProfile.json'
import nominaEs from './locales/es/nomina.json'
import asignarNovedadEs from './locales/es/asignarNovedad.json'
import agregarPeriodoModalEs from './locales/es/agregarPeriodoModal.json'
import newUserModalEs from './locales/es/newUserModal.json'
import invitarUsuarioModalEs from './locales/es/invitarUsuarioModal.json'
import inactiveUserEs from './locales/es/inactiveUser.json'
import confirmationModalEs from './locales/es/confirmationModal.json'
import loginEs from './locales/es/login.json'

import commonEn from './locales/en/common.json'
import errorsEn from './locales/en/errors.json'
import statusEn from './locales/en/status.json'
import layoutEn from './locales/en/layout.json'
import novedadesEn from './locales/en/novedades.json'
import validationEn from './locales/en/validation.json'
import historialEn from './locales/en/historial.json'
import novedadDetailsEn from './locales/en/novedadDetails.json'
import priorityChainEn from './locales/en/priorityChain.json'
import empresasEn from './locales/en/empresas.json'
import usuariosEn from './locales/en/usuarios.json'
import periodosEn from './locales/en/periodos.json'
import parametrosEn from './locales/en/parametros.json'
import parametrosDetailsEn from './locales/en/parametrosDetails.json'
import empresaParametrosEn from './locales/en/empresaParametros.json'
import empresaNovedadDetailsEn from './locales/en/empresaNovedadDetails.json'
import nominaUsuarioDetailsEn from './locales/en/nominaUsuarioDetails.json'
import filtrosEn from './locales/en/filtros.json'
import reintentarModalEn from './locales/en/reintentarModal.json'
import loginErrorModalEn from './locales/en/loginErrorModal.json'
import selectCompanyEn from './locales/en/selectCompany.json'
import protectedRouteEn from './locales/en/protectedRoute.json'
import accountProfileEn from './locales/en/accountProfile.json'
import nominaEn from './locales/en/nomina.json'
import asignarNovedadEn from './locales/en/asignarNovedad.json'
import agregarPeriodoModalEn from './locales/en/agregarPeriodoModal.json'
import newUserModalEn from './locales/en/newUserModal.json'
import invitarUsuarioModalEn from './locales/en/invitarUsuarioModal.json'
import inactiveUserEn from './locales/en/inactiveUser.json'
import confirmationModalEn from './locales/en/confirmationModal.json'
import loginEn from './locales/en/login.json'

// El idioma inicial lo decide languageStore (localStorage), no el detector
// del navegador — evita tener dos fuentes de verdad para el mismo dato. Este
// valor default solo importa para el primer render antes de que App.tsx
// sincronice i18n con el store.
export const SUPPORTED_LANGUAGES = ['es', 'en'] as const
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]

// El selector de idioma esta habilitado para todos los usuarios. Vacio =
// habilitado para todos (ver canSwitchLanguage).
export const LANGUAGE_SWITCHER_ALLOWLIST: string[] = []

export const canSwitchLanguage = (email?: string | null): boolean => {
  if (LANGUAGE_SWITCHER_ALLOWLIST.length === 0) return true
  return !!email && LANGUAGE_SWITCHER_ALLOWLIST.includes(email.trim().toLowerCase())
}

i18n.use(initReactI18next).init({
  resources: {
    es: {
      common: commonEs,
      errors: errorsEs,
      status: statusEs,
      layout: layoutEs,
      novedades: novedadesEs,
      validation: validationEs,
      historial: historialEs,
      novedadDetails: novedadDetailsEs,
      priorityChain: priorityChainEs,
      empresas: empresasEs,
      usuarios: usuariosEs,
      periodos: periodosEs,
      parametros: parametrosEs,
      parametrosDetails: parametrosDetailsEs,
      empresaParametros: empresaParametrosEs,
      empresaNovedadDetails: empresaNovedadDetailsEs,
      nominaUsuarioDetails: nominaUsuarioDetailsEs,
      filtros: filtrosEs,
      reintentarModal: reintentarModalEs,
      loginErrorModal: loginErrorModalEs,
      selectCompany: selectCompanyEs,
      protectedRoute: protectedRouteEs,
      accountProfile: accountProfileEs,
      nomina: nominaEs,
      asignarNovedad: asignarNovedadEs,
      agregarPeriodoModal: agregarPeriodoModalEs,
      newUserModal: newUserModalEs,
      invitarUsuarioModal: invitarUsuarioModalEs,
      inactiveUser: inactiveUserEs,
      confirmationModal: confirmationModalEs,
      login: loginEs,
    },
    en: {
      common: commonEn,
      errors: errorsEn,
      status: statusEn,
      layout: layoutEn,
      novedades: novedadesEn,
      validation: validationEn,
      historial: historialEn,
      novedadDetails: novedadDetailsEn,
      priorityChain: priorityChainEn,
      empresas: empresasEn,
      usuarios: usuariosEn,
      periodos: periodosEn,
      parametros: parametrosEn,
      parametrosDetails: parametrosDetailsEn,
      empresaParametros: empresaParametrosEn,
      empresaNovedadDetails: empresaNovedadDetailsEn,
      nominaUsuarioDetails: nominaUsuarioDetailsEn,
      filtros: filtrosEn,
      reintentarModal: reintentarModalEn,
      loginErrorModal: loginErrorModalEn,
      selectCompany: selectCompanyEn,
      protectedRoute: protectedRouteEn,
      accountProfile: accountProfileEn,
      nomina: nominaEn,
      asignarNovedad: asignarNovedadEn,
      agregarPeriodoModal: agregarPeriodoModalEn,
      newUserModal: newUserModalEn,
      invitarUsuarioModal: invitarUsuarioModalEn,
      inactiveUser: inactiveUserEn,
      confirmationModal: confirmationModalEn,
      login: loginEn,
    },
  },
  lng: 'es',
  fallbackLng: 'es',
  defaultNS: 'common',
  ns: [
    'common',
    'errors',
    'status',
    'layout',
    'novedades',
    'validation',
    'historial',
    'novedadDetails',
    'priorityChain',
    'empresas',
    'usuarios',
    'periodos',
    'parametros',
    'parametrosDetails',
    'empresaParametros',
    'empresaNovedadDetails',
    'nominaUsuarioDetails',
    'filtros',
    'reintentarModal',
    'loginErrorModal',
    'selectCompany',
    'protectedRoute',
    'accountProfile',
    'nomina',
    'asignarNovedad',
    'agregarPeriodoModal',
    'newUserModal',
    'invitarUsuarioModal',
    'inactiveUser',
    'confirmationModal',
    'login',
  ],
  interpolation: { escapeValue: false },
})

export default i18n
